/**
 * Available routes within the application.
 */
export const Routes: Record<string, string> = {
    COMPOUNDS: '/compounds',
    TARGETS: '/targets',
    DRIVERS: '/drivers',
    IFU: '/ifu',
    LABEL: '/product-label',
    DISCLAIMER: '/disclaimer',
    NOT_FOUND: '/not-found',
    BASE: '/'
}